// src/components/ClientsSection.jsx
import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Tooltip,
  useTheme
} from '@mui/material';
import { motion } from 'framer-motion';

// pulled from your websites/projects list:
const clients = [
  { name: 'Kirupam',         logo: 'https://kirupam.com/logo.png',         url: 'https://kirupam.com/' },
  { name: 'PKMK Construction', logo: 'https://pkmkconstruction.co.uk/pkmklogo.png', url: 'https://pkmkconstruction.co.uk/' },
  { name: 'Sai Builders',    logo: 'https://saibuilders.co.uk/saiblogo.png',      url: 'https://saibuilders.co.uk/' },
  { name: 'RichShelf',       logo: 'https://richshelf.co.uk/wp-content/uploads/2024/12/cropped-Rich-shelf-7-600x200.png',        url: 'https://richshelf.co.uk/' },
  { name: 'World Chiller',   logo: 'https://worldchiller.co.uk/wp-content/uploads/2024/12/WhatsApp-Image-2024-12-31-at-19.29.47-e1735653887841-300x161.jpeg',     url: 'https://worldchiller.co.uk/' },
  { name: 'Yoan Wholesale',  logo: 'https://yoanwholesale.co.uk/wp-content/uploads/2025/01/cropped-WhatsApp-Image-2025-01-18-at-16.30.21-1-600x162.jpeg',    url: 'https://yoanwholesale.co.uk/' },
  { name: 'Dubai Shopping',  logo: 'https://dubaishopping.lk/wp-content/uploads/2024/12/DUBAI-tr1-e1678953756420-600x187.png',    url: 'https://dubaishopping.lk/' },
  { name: 'AlRahman Int’l',  logo: 'https://alrahmaninternational.co.uk/admin/uploads/AL%20Rahman%20international%20(2).png',         url: 'https://alrahmaninternational.co.uk/' },
  { name: 'KRS Cake City',   logo: 'https://krscakecity.com/static/media/logo.0ef3424daee6029d601b.png',      url: 'https://krscakecity.com/' },
  { name: 'Ranjan & Co',     logo: 'https://ranjanandco.com/logos/WhatsApp%20Image%202025-06-09%20at%204.39.54%20PM.jpeg',      url: 'https://ranjanandco.com/' },
  { name: 'DEST',            logo: 'https://dest.lk/wp-content/uploads/2022/01/cropped-Logo2-removebg-preview-300x100.png',             url: 'https://dest.lk/' },
  // you can add more client entries here…
];

export default function ClientsSection() {
  const theme = useTheme();

  return (
    <Box
      component={motion.section}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      sx={{
        bgcolor: 'background.paper',
        py: { xs: 6, md: 8 },
      }}
    >
      <Container>
        <Typography
          variant="h5"
          align="center"
          fontWeight={600}
          color="text.primary"
          gutterBottom
        >
          Trusted by Leading Brands
        </Typography>

        <Grid container spacing={4} justifyContent="center" sx={{ mt: 2 }}>
          {clients.map((c, i) => (
            <Grid item xs={6} sm={4} md={3} key={i}>
              <Tooltip title={c.name} arrow>
                <Box
                  component={motion.a}
                  href={c.url}
                  target="_blank"
                  rel="noopener"
                  whileHover={{ scale: 1.1 }}
                  transition={{ type: 'spring', stiffness: 300 }}
                  sx={{
                    display: 'block',
                    height: 80,
                    m: 'auto',
                    filter: 'grayscale(1)',
                    opacity: 0.7,
                    '&:hover': {
                      filter: 'grayscale(0)',
                      opacity: 1,
                    },
                  }}
                >
                  <Box
                    component="img"
                    src={c.logo}
                    alt={c.name}
                    sx={{
                      maxHeight: '100%',
                      maxWidth: '100%',
                      objectFit: 'contain',
                    }}
                  />
                </Box>
              </Tooltip>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
